import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    scrollBox: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      },
      tableContainer: {
        flex: '1 1 auto',
        margin: `${theme.spacing(3)} 0 0`,
        padding: `0 0 ${theme.spacing(3)}`,
        height: '400px',
      },
      actionRow: {
        display: 'flex',
        marginTop: '10px'
      },
      confirm: {
        margin: '0 0 0 12px',
      },
      button: {
        padding: '0.3rem 1rem',
        fontSize: '12px',
        margin: '0 0 0 12px',
        '&:first-child': {
          margin: 0,
        },
      },
      unSelected: {
        color: theme.palette.grey[500],
      },
      dropdown: {
        minWidth: 50,
        maxWidth: 300,
        width: '100%',
        textOverflow: 'ellipsis',
        height: 30,
        marginLeft:'10px',
        transform: 'translateY(-10px)',
      },
      box: {
        maxHeight: '30px',
        minHeight: '30px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'left',
    },
    dialog: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '100%',
    },
    overFlowEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    iconButton: {
      padding: 0,
    },
  textField: {
    width: '300px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    transform: 'translateY(-10px)',
  },
    vimsTableContainer: {
      height: '320px',
      // marginTop: '10px'
    },
    leftAlign: {
      marginLeft: '10px'
    },
    saveButton: {
      backgroundColor:theme.palette.grey[300],
    }
}));

export default useStyles;